export default {
  appointment: {
    created: 'Appointment created successfully',
    updated: 'Appointment updated',
    cancelled: 'Appointment cancelled',
    confirmed: 'Appointment confirmed',
    reminder: 'Reminder: Appointment in {{time}}',
    create_error: 'Error creating appointment',
    update_error: 'Error updating appointment',
    deleted: 'Appointment deleted',
    delete_error: 'Error deleting appointment',
    confirm_error: 'Error confirming appointment',
    cancel_error: 'Error cancelling appointment',
    noshow_marked: 'Appointment marked as absent',
    noshow_error: 'Error marking appointment as absent'
  },
  teleconsult: {
    started: 'Teleconsultation started',
    ended: 'Teleconsultation ended',
    urgent: 'New urgent teleconsultation!',
    waitingRoom: 'You are in the waiting room',
    prescription_received: 'You have received a new electronic prescription.',
    about_to_start: '🚀 Your consultation is about to start!',
    cancelled_toast: '❌ Consultation cancelled'
  },
  auth: {
    loginSuccess: 'Welcome, {{name}}!',
    loginError: 'Invalid credentials',
    logout: 'Logged out successfully',
    sessionExpired: 'Session expired, please log in again',
    mfaRequired: 'MFA Code required',
    mfaSuccess: 'MFA Authentication successful'
  },
  patient: {
    created: 'Patient created successfully',
    updated: 'Patient information updated',
    shortNumberGenerated: 'Short number generated: {{number}}',
    create_error: 'Error creating patient',
    updated_success: 'Patient updated successfully',
    update_error: 'Error updating patient',
    deleted: 'Patient deleted',
    delete_error: 'Error deleting patient',
    short_number_error: 'Error generating short number'
  },
  call: {
    incoming: 'Incoming call from {{caller}}',
    incoming_generic: 'Incoming call',
    accepted: 'Call accepted',
    declined: 'Call declined',
    calling: 'Calling...',
    connected: 'Call connected',
    ended: 'Call ended',
    failed: 'Call failed',
    video_connected: 'Video connection established',
    video_lost: 'Video connection lost',
    camera_changed: 'Camera changed',
    camera_change_failed: 'Unable to change camera',
    mic_enabled: 'Microphone enabled',
    mic_disabled: 'Microphone disabled',
    cam_enabled: 'Camera enabled',
    cam_disabled: 'Camera disabled',
    reconnecting: 'Reconnecting... ({{current}}/{{max}})',
    connection_lost_restart: 'Connection lost. Please restart the call.',
    webrtc_error: 'WebRTC error: {{error}}',
    media_access_failed: 'Unable to access camera/microphone',
    offer_failed: 'Error creating offer',
    answer_failed: 'Error creating answer',
    remote_desc_failed: 'Error setting remote description'
  },
  network: {
    offline: 'Connection lost',
    online: 'Connection restored',
    slowConnection: 'Slow connection detected...',
    unavailable: 'Connection unavailable.',
    unavailable_retry: 'Connection unavailable. Please wait.',
    retrying: 'Attempt {{attempt}}/{{max}}... Retrying in {{delay}}s',
    attempt: 'Attempt {{attempt}}/{{max}}',
    nextAttempt: 'Next attempt in {{seconds}}s',
    retryNow: 'Retry now',
    cancel: 'Cancel',
    statusOffline: 'Offline',
    statusSlow: 'Slow connection',
    statusGood: 'Good connection',
    statusExcellent: 'Excellent connection'
  },
  monitoring: {
    memory_critical: 'Critical memory usage',
    high_latency: 'High network latency',
    packet_loss: 'Packet loss detected',
    no_metrics: 'No metrics available'
  },
  appointments: {
    loadDoctorsError: 'Error loading doctors',
    requestSent: 'Request sent to the doctor pending validation',
    confirmError: 'Unable to confirm: {{error}}',
    slotNotOpen: 'This slot is not open for automatic booking.',
    slotPending: 'This slot already has a pending appointment request.',
    slotOccupied: 'This slot is already occupied.'
  },
  chat: {
    sendError: 'Error sending message',
    emergencyAlertSent: 'Emergency alert sent',
    emergencyAlertError: 'Error sending the alert',
    newMessage: 'New message'
  }
};
